module.exports = __webpack_public_path__ + "assets/img/pdf_preview2.45c07762.svg";